import { render, staticRenderFns } from "./ResumenVentas.vue?vue&type=template&id=50dd2d53&scoped=true"
import script from "./ResumenVentas.vue?vue&type=script&lang=js"
export * from "./ResumenVentas.vue?vue&type=script&lang=js"
import style0 from "./ResumenVentas.vue?vue&type=style&index=0&id=50dd2d53&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50dd2d53",
  null
  
)

export default component.exports